import { connect } from 'react-redux';
import Container from '../components/Container';
import { updateMessage, addMessage, retryMessage } from '../actions'

// Container: Connect store state to components
export const StateContainer = connect(
	function mapStateToProps(state) {
		return { 
			client: state.client,
			currentMessage: state.currentMessage,
			messages: state.messages,
			suggestedResponses: state.suggestedResponses,
			messageLoader: state.messageLoader,
			pageState: state.pageState
		};
	},
	function mapDispatchToProps(dispatch) {
		return {
			updateMessage: text => dispatch(updateMessage(text)),
			addMessage: text => dispatch(addMessage(text)),
			retryMessage: message => dispatch(retryMessage(message)),
			addPostBack: object => {
				dispatch(addMessage(object.get("body"), object.get("type"), object.get("responseId")))
			}
		}
	}
)(Container);


// WEBPACK FOOTER //
// ./src/containers/index.js